import {
  DATEPICKER,
  PAXPICKER,
  CITYPICKER,
  DEFAULT_PAX_VALUE,
  MONTHS,
  DAYS,
  MONTHS_NUM,
  COUNTRY_CODES,
  DOMAINS,
} from './constants';
import {
  CHILD_AGE_PLACEHOLDER,
  BED_REQUIRED_ENUM,
  PAX_CONFIG,
} from './SelectPax/Constant/constants';

export const getCountry = hostname => {
  if (typeof window !== 'undefined' && window.ccde) {
    const key = COUNTRY_CODES[window.ccde];
    if (key) {
      return key;
    }
  }
  const domain = getBaseHostName(hostname);
  // eslint-disable-next-line no-restricted-syntax
  for (const key in COUNTRY_CODES) {
    if (DOMAINS[key] === domain) {
      return key;
    }
  }
  return COUNTRY_CODES.IN;
};

const getBaseHostName = hostname => {
  let host;
  host = '';
  if (ssr.isOnClient) {
    host = window.location.hostname;
  } else if (hostname) {
    host = hostname;
  } else if (!isOnClient && typeof global !== 'undefined') {
    host = undefined;
  }
  host = host && host.replace('www.', '').replace(':8000', '');
  return host || 'makemytrip.com';
};

const getDisplayValue = (type, value) => {
  let displayValue = '';
  switch (type) {
    case DATEPICKER:
      displayValue = getFormattedDate(value);
      break;
    case PAXPICKER:
      displayValue = getFormattedPax(value);
      break;
    case CITYPICKER:
      displayValue = value;
      break;
    default:
      break;
  }

  return displayValue;
};

const isValidPax = pax => {
  // eslint-disable-next-line no-plusplus
  for (let index = 0; index < pax.length; index++) {
    const room = pax[index];
    if (
      room.children &&
      room.children.length &&
      room.children.some(age => age === CHILD_AGE_PLACEHOLDER)
    ) {
      alert('Please select child age.');
      return false;
    }
  }

  return true;
};

const addDays = (days = 0, date) => {
  const updatedDate = new Date(date);
  updatedDate.setDate(updatedDate.getDate() + days);
  return updatedDate;
};
const addMonths = (months = 0, date) => {
  const updatedDate = new Date(date);
  updatedDate.setMonth(updatedDate.getMonth() + months);
  return updatedDate;
};

const getFormattedDate = date => {
  // Ex: format: Thu, 16 Apr 2020
  let formattedStr = '';
  if (date) {
    const dd = date.getDate();
    const month = MONTHS[date.getMonth()];
    const year = date.getFullYear();
    const day = DAYS[date.getDay()];

    formattedStr = `${day}, ${dd} ${month} ${year}`;
  }

  return formattedStr;
};
const getFormattedDateForPayload = date => {
  // Ex: format: 2020-12-28
  let formattedStr = '';
  if (date) {
    let dd = date.getDate();
    const month = MONTHS_NUM[date.getMonth()];
    const year = date.getFullYear();
    if (dd < 10) {
      dd = `0${dd}`;
    }
    formattedStr = `${year}-${month}-${dd}`;
  }

  return formattedStr;
};

const getFormattedAdult = count => (count > 1 ? 'Adults' : 'Adult');
const getFormattedChild = count => (count > 1 ? 'Children' : 'Child');

export const getFormattedPax = pax => {
  // Ex: format: 2 Adults, 1 Child
  // Ex: format: 2 Adults, 2 Children
  let formattedStr = '';
  let adultCount = 0;
  let childCount = 0;
  const paxValues = pax || DEFAULT_PAX_VALUE;

  paxValues.forEach(({ adults, children }) => {
    if (adults) {
      adultCount += adults;
    }
    if (children) {
      childCount += children.length;
    }
  });
  if (adultCount) {
    formattedStr = `${adultCount} ${getFormattedAdult(adultCount)}`;
  }
  if (childCount) {
    formattedStr += `, ${childCount} ${getFormattedChild(childCount)}`;
  }

  return formattedStr;
};

export const getDateAfterMonth = month => {
  const today = new Date();
  const currentDateAfterMonth = new Date();
  currentDateAfterMonth.setMonth(today.getMonth() + month);
  const lastDate = new Date(
    currentDateAfterMonth.getFullYear(),
    currentDateAfterMonth.getMonth() + 1,
    0
  );
  return lastDate;
};

export const getDateAfterDays = (days, destinationCity = '') => {
  const today = new Date();
  const currentDateAfterDays = new Date();
  if (destinationCity === 'Goa') currentDateAfterDays.setDate(today.getDate());
  else currentDateAfterDays.setDate(today.getDate() + days);
  return currentDateAfterDays;
};

export const modifyPaxFormat = (pax, paxConfig, isListing = true) => {
  const {
    childWithBed = PAX_CONFIG.childWithBed,
    minChildAge = PAX_CONFIG.minChildAge,
    minChildAgeForBedCompulsory = PAX_CONFIG.maxChildAge,
  } = paxConfig || {};
  const paxDetail = [];
  for (const index in pax) {
    const paxDetailObj = {};
    paxDetailObj.noOfAdults = pax[index].adults;
    paxDetailObj.noOfChildrenWB = 0;
    paxDetailObj.listOfAgeOfChildrenWB = [];
    paxDetailObj.noOfInfants = 0;
    paxDetailObj.listOfInfAge = [];
    paxDetailObj.noOfChildrenWOB = 0;
    paxDetailObj.listOfAgeOfChildrenWOB = [];
    if (!childWithBed) {
      for (const i in pax[index].children) {
        if (pax[index].children[i] < minChildAge) {
          paxDetailObj.noOfInfants++;
          paxDetailObj.listOfInfAge.push(pax[index].children[i]);
        } else {
          paxDetailObj.noOfChildrenWOB++;
          paxDetailObj.listOfAgeOfChildrenWOB.push(pax[index].children[i]);
        }
      }
    } else if (pax[index]?.children?.length > 0) {
      if (pax[index].children.length <= 1) {
        if (pax[index].children[0] < minChildAge) {
          paxDetailObj.noOfInfants++;
          paxDetailObj.listOfInfAge.push(pax[index].children[0]);
        } else if (pax[index].children[0] > minChildAgeForBedCompulsory) {
          paxDetailObj.noOfChildrenWB++;
          paxDetailObj.listOfAgeOfChildrenWB.push(pax[index].children[0]);
        } else if (pax[index].childBedRequired[0] === BED_REQUIRED_ENUM.No) {
          paxDetailObj.noOfChildrenWOB++;
          paxDetailObj.listOfAgeOfChildrenWOB.push(pax[index].children[0]);
        } else {
          paxDetailObj.noOfChildrenWB++;
          paxDetailObj.listOfAgeOfChildrenWB.push(pax[index].children[0]);
        }
      } else {
        const maxAgeAdded = Math.max(...pax[index].children);
        const maxAgeAddedIndex = pax[index].children.indexOf(maxAgeAdded);
        for (const i in pax[index].children) {
          if (+i === maxAgeAddedIndex) {
            paxDetailObj.noOfChildrenWB++;
            paxDetailObj.listOfAgeOfChildrenWB.push(pax[index].children[i]);
          } else if (pax[index].children[i] < minChildAge) {
            paxDetailObj.noOfInfants++;
            paxDetailObj.listOfInfAge.push(pax[index].children[i]);
          } else {
            paxDetailObj.noOfChildrenWOB++;
            paxDetailObj.listOfAgeOfChildrenWOB.push(pax[index].children[i]);
          }
        }
      }
    }
    paxDetail.push(paxDetailObj);
  }
  return paxDetail;
};

export const demodifyPaxFormat = pax => {
  const paxDetail = [];
  for (const index in pax) {
    const paxDetailObj = {};
    paxDetailObj.adults = pax[index].noOfAdults;
    paxDetailObj.children = [];
    paxDetailObj.childBedRequired = [];
    for (const i in pax[index].listOfAgeOfChildrenWB) {
      paxDetailObj.children.push(pax[index].listOfAgeOfChildrenWB[i]);
      paxDetailObj.childBedRequired.push(BED_REQUIRED_ENUM.Yes);
    }
    for (const i in pax[index].listOfInfAge) {
      paxDetailObj.children.push(pax[index].listOfInfAge[i]);
      paxDetailObj.childBedRequired.push(BED_REQUIRED_ENUM.No);
    }
    if (pax[index].listOfAgeOfChildrenWOB) {
      for (const i in pax[index].listOfAgeOfChildrenWOB) {
        paxDetailObj.children.push(pax[index].listOfAgeOfChildrenWOB[i]);
        paxDetailObj.childBedRequired.push(BED_REQUIRED_ENUM.No);
      }
    }
    paxDetail.push(paxDetailObj);
  }
  return paxDetail;
};

export const getTotalPaxCount = roomListString => {
  const totalPaxCount = { adultCount: 0, childCount: 0, infantCount: 0, totalCount: 0 };
  for (const room of roomListString) {
    totalPaxCount.adultCount += room.noOfAdults;
    // Changed after discussion with Madhur Mittal.
    totalPaxCount.childCount +=
      room.noOfChildrenWB == null
        ? 0
        : room.noOfChildrenWB + room.noOfChildrenWOB == null
          ? 0
          : room.noOfChildrenWOB;
    totalPaxCount.infantCount += room.noOfInfants == null ? 0 : room.noOfInfants;
  }
  totalPaxCount.totalCount =
    totalPaxCount.adultCount + totalPaxCount.childCount + totalPaxCount.infantCount;
  return totalPaxCount;
};

export const addDay = (date, day) => new Date(date.setDate(date.getDate() + day));

export const monthDiffernce = sortedDateArray => {
  const fromDate = new Date(sortedDateArray[0]?.start);
  const toDate = new Date(sortedDateArray[sortedDateArray.length - 1]?.end);
  const yearDiff = toDate?.getFullYear() - fromDate?.getFullYear();
  return yearDiff * 12 + toDate.getMonth() - fromDate.getMonth() + 1;
};

export default {
  getDisplayValue,
  isValidPax,
  addDays,
  addMonths,
  getFormattedPax,
  getFormattedAdult,
  getFormattedChild,
  getFormattedDate,
  getDateAfterMonth,
  getDateAfterDays,
  modifyPaxFormat,
  demodifyPaxFormat,
  getFormattedDateForPayload,
  getTotalPaxCount,
};
